<template>
  <main :class="$style.view" v-if="page.fields">
    <random-image-list :list="page.featured" />
  </main>
</template>

<script>
import PageService from '@/services/page'
import RandomImageList from '@/components/random-image-list'

export default {
  components: { RandomImageList },
  data() {
    return {
      page: {}
    }
  },
  async created() {
    this.page = await PageService.get({ id: this.$route.name })
    if (this.page.fields.news) {
      this.$store.commit('setNewsLine', {
        newsLine: this.page.fields.news
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    const transition = to.meta.template === 'artist' ? 't-artist' : 't-fade'
    this.$store.dispatch('setTransitionName', {
      transition: transition
    })
    this.$store.dispatch('setNavVisibility', {
      navVisible: false
    })
    next()
  }
}
</script>

<style lang="scss" module>
.view {
  height: 100%;
  // padding-top: calc(var(--gutter) * 7);
  // padding-right: var(--gutter);
  // padding-bottom: var(--gutter);
  // padding-left: var(--gutter);

  // @media (min-width: $medium) {
  //   padding-top: calc(var(--gutter) * 3);
  // }
}
</style>
